/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
import { run } from './CrownScanViewer';

run(document.getElementById('viewer'));
